import { render, staticRenderFns } from "./TheEvent.vue?vue&type=template&id=b6266572&"
import script from "./TheEvent.vue?vue&type=script&lang=js&"
export * from "./TheEvent.vue?vue&type=script&lang=js&"
import style0 from "./TheEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports